module.exports = __webpack_public_path__ + "static/media/Lato-Italic.7582e823.ttf";